'use client'

import { delmanTerms } from '@/features/delman/delmanTerms'
import { useKitchenSyncStatus } from '@/shared/sync/useKitchenSyncStatus'

export function DelmanSyncStatusIndicator() {
  const { online, pendingCount, isFlushing, flush } = useKitchenSyncStatus()

  const dotClass = online ? 'bg-status-success' : 'bg-status-danger'
  const label = !online
    ? delmanTerms.sync.offline
    : pendingCount > 0
      ? delmanTerms.sync.pending(pendingCount)
      : delmanTerms.sync.online

  return (
    <button
      type="button"
      onClick={() => {
        if (online && pendingCount > 0) void flush()
      }}
      disabled={!online || pendingCount === 0 || isFlushing}
      className="flex items-center gap-1.5 max-w-[120px] text-left disabled:cursor-default"
      title={
        pendingCount > 0 && online
          ? delmanTerms.sync.tapToRetry
          : delmanTerms.sync.statusTitle
      }
    >
      <span className={`h-2 w-2 shrink-0 rounded-full ${dotClass}`} aria-hidden />
      <span className="text-caption text-inverse-on-surface/70 leading-tight truncate">
        {isFlushing ? delmanTerms.sync.flushing : label}
      </span>
    </button>
  )
}
